import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _styled from "@emotion/styled/base";
var _excluded = ["children", "onClick", "disabled", "url", "variant"];

var _templateObject;

import React from "react";
import shouldForwardProp from "@styled-system/should-forward-prop";
import { border, color, compose, css, display, flexbox, maxWidth, minHeight, space, typography } from "@catchoftheday/theme";
import { Button } from "../Button";
import { Link } from "../Link";
import { jsx as ___EmotionJSX } from "@emotion/react";
var styleProps = compose(border, space, color, display, typography, flexbox, minHeight, maxWidth);

var TagWrap = /*#__PURE__*/_styled("div", true ? {
  shouldForwardProp: shouldForwardProp,
  target: "enh4ozu0"
} : {
  shouldForwardProp: shouldForwardProp,
  target: "enh4ozu0",
  label: "TagWrap"
})("border-radius:2px;border-left:2.5px solid;", styleProps, " ", function (props) {
  if (props.url) {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        text-decoration: underline;\n      "])));
  }
}, ";" + (true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

TagWrap.defaultProps = {
  p: "3px 8px 3px 6px",
  backgroundColor: "brand.primaryLight",
  display: "inline-flex",
  alignItems: "center",
  color: "text",
  fontSize: "sm",
  maxWidth: "100%",
  borderColor: "brand.primary"
};
var variants = {
  primary: {
    backgroundColor: "brand.primaryLight",
    borderColor: "brand.primary"
  },
  secondary: {
    backgroundColor: "brand.tertiaryLight",
    borderColor: "brand.tertiary"
  },
  onepass: {
    backgroundColor: "onePass.primaryLighter",
    borderColor: "onePass.primary"
  }
};
export var CalloutTag = function CalloutTag(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      url = _ref.url,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "primary" : _ref$variant,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var variantProps = variants[variant];

  if (url) {
    return ___EmotionJSX(Link, {
      href: url
    }, ___EmotionJSX(TagWrap, _extends({
      url: url
    }, otherProps, variantProps), children));
  }

  if (onClick) {
    return ___EmotionJSX(Button, {
      onClick: onClick,
      variant: "plain",
      m: 0,
      p: 0,
      minWidth: "0px!important",
      textTransform: "none"
    }, ___EmotionJSX(TagWrap, _extends({}, otherProps, variantProps), children));
  }

  return ___EmotionJSX(TagWrap, _extends({}, otherProps, variantProps), children);
};
CalloutTag.displayName = "CalloutTag";
export default CalloutTag;